// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Api } from "../../../api";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class FinArchivModule extends ModuleBase {
  private isFinModalVisible = false;

  private fin: string = "";

  private selectedAufbaurichtlinienLanguage = "";

  private selectedAufbaurichtlinienForDownload = [];

  private finData: object | null = null;

  private isModalVisible: boolean = false;

  private isFinDataLoading: boolean = false;

  @Watch("selectedAufbaurichtlinienLanguage")
  private onSelectedAufbaurichtlinienLanguageChange() {
    this.selectedAufbaurichtlinienForDownload = [];
  }

  get tableColumns() {
    if (this.finData && !this.finData["error"]) {
      return {
        name: {
          name: this.finData["spalten"][0],
          sortable: false,
        },
        type: {
          name: this.finData["spalten"][1],
          sortable: false,
        },
        links: {
          name: this.finData["spalten"][2],
          sortable: false,
        },
      };
    } else {
      return {};
    }
  }

  get tableData() {
    if (this.finData && !this.finData["error"]) {
      let data = this.finData["datenblaetter"];

      if (
        this.finData["aufbaurichtlinien"] &&
        this.finData["aufbaurichtlinien"].length > 0
      ) {
        let languages = this.finData["aufbaurichtlinien"]
          .map((a) => a["language"])
          .filter((v, i, a) => a.indexOf(v) === i);
        languages.sort();

        data.push({
          name: this.finData["aufbaurichtlinien_label"],
          type: "pdf",
          links: {
            select: languages,
          },
        });
      }

      return data;
    } else {
      return [];
    }
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  private async loadData() {
    this.isFinDataLoading = true;

    this.selectedAufbaurichtlinienLanguage = "";
    this.isModalVisible = false;
    this.finData = null;
    this.finData = await Api.katalogService.finArchivAbfragen(this.fin);

    if (this.finData && !this.finData["error"]) {
      this.isModalVisible = true;
    }

    this.isFinDataLoading = false;
  }

  private onDownload() {
    // @ts-ignore
    this.$refs["downloadForm"].$el.submit();
  }

  public onModalClose() {
    this.isModalVisible = false;
  }
}
